import React from 'react'
import Footer from '../../COMPONENTS/Footer/Footer'
import { useState, useEffect } from 'react';
import Loading from '../../COMPONENTS/Loading/Loading'
import BackImage from './BackImage';
import botanique from '../../../ASSETS/tourisme/Image/image_loisirs/botanique.png'
import galerie from '../../../ASSETS/tourisme/Image/image_loisirs/galerieCecile.png'
import mall from '../../../ASSETS/tourisme/Image/image_loisirs/Mall.png'
import cosmos from '../../../ASSETS/tourisme/Image/image_loisirs/cosmos.png'
import sofitel from '../../../ASSETS/tourisme/Image/image_loisirs/sofitel-abidjan-hotel.png'
import muse from '../../../ASSETS/tourisme/Image/image_loisirs/Musée_des_civilisations1.png'
import { GiMoneyStack } from "react-icons/gi";
import { IoMdPin } from "react-icons/io";
import Barniere from './Barniere';
import {Link} from 'react-router-dom'
import Culture from '../../../API/tourisme/loisir/index'
import { AnnoncesProps} from "../../../props";
import { useTranslation } from 'react-i18next';
import { ResultContext } from '../../../ResultContext';

function Loisirs() {

    function truncate (str : any) {
        return str.length > 200 ? str.substring(0, 200) + "..." : str;
    }

    const [loading, setLoading] = useState(true);
    
    
    const [loisir, setLoisir] = useState<AnnoncesProps[]>([]);
    const [filter, setFilter] = useState('Tout');
    const [filteredLoisir, setFilteredLoisir] = useState(loisir);
    const contexts = React.useContext(ResultContext)
    
    let code = localStorage.getItem('code') ? localStorage.getItem('code') : localStorage.getItem('is_code');
    const getAllLoisir = () => {
      Culture.getAllData(code)
        .then((res: any) => {
          if (res.data.status === 200 && contexts?.results.loisire === null) {
            setLoisir(res.data.data);
          }
        })
        .catch((err: any) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    };
  
    useEffect(() => {
      getAllLoisir();
  
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000);
  
      return () => clearTimeout(timer);
    }, []);
  
    useEffect(() => {
      const isPopular = (activity: AnnoncesProps) => {
        //return activity.views > 100;
      };
  
      const isRecommended = (activity: AnnoncesProps): boolean => {
        const today = new Date();
        const dateDebut = new Date(activity.date_debut);
        const timeDifference = today.getTime() - dateDebut.getTime();
        const daysDifference = timeDifference / (1000 * 3600 * 24);
        return daysDifference <= 3;
      };
  
      const filterLoisir = () => {
        if (filter === 'Tout') return loisir;
        if (filter === 'Les plus populaires') return loisir.filter(isPopular);
        if (filter === 'Recommandée') return loisir.filter(isRecommended);
        return loisir;
      };
  
      setFilteredLoisir(filterLoisir());
    }, [filter, loisir]);

    useEffect(()=>{
      if(contexts?.results.loisire)
        {
          setLoisir(contexts?.results.loisire);
        }
    },[contexts?.results.loisire])
          
    
    const {t} = useTranslation() as {t:(key:string)=>string}
    let authUser: { userId: number } | null = JSON.parse(localStorage.getItem('data') || 'null');


  return (
    <div>
          {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          
          <BackImage/>

          {/* filtre */}
            <div className='flex pt-8 pl-10 s:flex-col xs:flex-row xs:space-x-4 s:space-y-4 xs:space-y-0'>
              <button
                className={`w-[200px] h-10 ${filter === 'Tout' ? 'bg-[#233D4D] text-white' : 'border-[#233D4D] border-2 text-[#233D4D]'} text-lg hover:bg-white hover:text-[#233D4D] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300`}
                onClick={() => setFilter('Tout')}
              >
                {t("Tout")}
              </button>
              <button
                className={`w-[200px] h-10 ${filter === 'Les plus populaires' ? 'bg-[#233D4D] text-white' : 'border-[#233D4D] border-2 text-[#233D4D]'} text-lg hover:bg-white hover:text-[#233D4D] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300`}
                onClick={() => setFilter('Les plus populaires')}
              >
                {t("Les plus populaires")}
              </button>
              <button
                className={`w-[200px] h-10 ${filter === 'Recommandée' ? 'bg-[#233D4D] text-white' : 'border-[#233D4D] border-2 text-[#233D4D]'} text-lg hover:bg-white hover:text-[#233D4D] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300`}
                onClick={() => setFilter('Recommandée')}
              >
                {t("Recommandée")}
              </button>
            </div>

            {/* Les activitées */}
            <div className='grid my-10 md:grid-cols-3 xs:grid-cols-2 s:grid-cols-1 gap-y-14 place-items-center'>
            {filteredLoisir.map((list, index )=> (
                <div className='xs:w-[360px] sm:w-[320px] s:w-[260px]'>
                    <img className='w-[360px] rounded' src={`data:image/png;base64,${list[0]}`} alt={list.title_announce} />
                    {/* description */}
                    <p className='text-lg text-[#fe7f2d] font-semibold py-3'>{list.title_announce}</p>
                    <p className='xs:w-[350px] sm:w-[320px] s:w-[270px]'>{truncate(list.description_announce)}</p>

                    {/* lieu et prix */}
                    <div className='flex py-4 xs:flex-row s:flex-col xs:items-center xs:space-x-3 s:space-y-3 xs:space-y-0'>
                        <div className='flex flex-row items-center space-x-2 font-thin '>
                        <IoMdPin className='text-xl text-[#fe7f2d]' />
                        <p>{list.contact_address}</p>
                        </div>
                        <div className='flex flex-row items-center space-x-2 font-thin '>
                            <GiMoneyStack className='text-xl text-green-600' />
                            <p > {list.price_announce} FCFA</p>
                        </div>
                    </div>

                   <div className='flex justify-between'>
                         {/* Acheter un tiket */}
                         {
                            authUser && authUser.userId !== list?.made_by  && (
                              <Link to='/Reservation_Loisirs'
                              state={ 
                                  list.id_announce 
                                 }
                              >
                                  <div className='grid place-content-end'>
                                      <button className='hover:bg-[white] w-[150px] h-10 rounded bg-[#fe7f2d]  text-[white] hover:text-[#fe7f2d] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-700'>Acheter un ticket</button>
                                  </div>
                              </Link>
                            )
                         }
                       
                        {/* decouvrir */}
                        <Link to="/Loisirs_Activite/Voir_Plus/#voir-plus"
                        state={ 
                            list.id_announce 
                           }
                        >
                        <div className='grid place-content-end'>
                            <button className='bg-[#233D4D] w-[100px] h-10 text-white rounded hover:bg-white hover:text-[#233D4D] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-700'>Decouvrir</button>
                        </div>
                        </Link>
                   </div>
                </div>
                )
                )}
            </div>

           <Barniere/>

          <Footer/>
        </>
      )}
    </div>
  )
}

export default Loisirs